import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'mobily-ui-library/fonts.css';
import 'mobily-ui-library/style.css';
if (import.meta.env.DEV) {
  await import('./local.tsx');
}
import './index.scss'
import './fonts.scss'
import App from './App.tsx'
import './i18n';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorPopup } from 'mobily-ui-library';
import { defaultApiErrorState } from './stores/globalStore.ts';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary fallback={<ErrorPopup
      errorText={defaultApiErrorState?.message ?? ''}
      tryAgainText={defaultApiErrorState?.retryText ?? ''}
      closeText={''}
      onClose={() => {}}
      onRetry={() => {
        window.location.reload();
      }}
    />}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
